import React from 'react'
import { styled } from '@mui/material/styles'
import {
  ArrayInput,
  FormDataConsumer,
  required,
  SimpleFormIterator,
} from 'react-admin'
import { ruleOperatorChoices, ruleWhatChoices } from 'services/cfg/form'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import ProductsByServiceSelector from './ProductsByServiceSelector'
import KToolTip from 'ui-shared/KTooltip'
import { FormDataConsumerProps } from 'types/common'
import { IfClauseToApi, Rule } from 'services/api/entities/Rules'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
const PREFIX = 'IfClauseForm'

const classes = {
  dFlexRow: `${PREFIX}-dFlexRow`,
  inputW250px: `${PREFIX}-inputW250px`,
  inputW800px: `${PREFIX}-inputW800px`,
  w100: `${PREFIX}-w100`,
}

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')({
  [`& .${classes.dFlexRow}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '100%',
  },
  [`& .${classes.inputW250px}`]: {
    width: '250px',
  },
  [`& .${classes.inputW800px}`]: {
    width: '800px',
  },
  [`& .${classes.w100}`]: {
    width: '100%',
  },
})

const IfClauseForm: React.FC = (props) => {
  return (
    <Root>
      <Kdivider title="IF" />
      <ArrayInput
        {...props}
        label=""
        source="if"
        fullWidth
        className={classes.w100}
      >
        <SimpleFormIterator>
          <FormDataConsumer>
            {({
              getSource,
              scopedFormData,
            }: FormDataConsumerProps<Rule, IfClauseToApi>) => (
              <div className={classes.dFlexRow}>
                <KToolTip title="form.fields.ruleWhatTooltip" placement="top">
                  <KSelectInput
                    label="form.fields.ruleWhat"
                    className={classes.inputW250px}
                    source={getSource!('what')}
                    choices={ruleWhatChoices}
                    validate={required()}
                  />
                </KToolTip>
                <ProductsByServiceSelector
                  serviceTooltipText="form.fields.ifClauseServiceTooltip"
                  productsTooltipText="form.fields.ifClauseProductsTooltip"
                  getSource={getSource}
                  scopedFormData={scopedFormData}
                />
              </div>
            )}
          </FormDataConsumer>
          <KSelectInput
            label="form.fields.rulesOperator"
            source="operator"
            className={classes.inputW250px}
            choices={ruleOperatorChoices}
            defaultValue="and"
          />
        </SimpleFormIterator>
      </ArrayInput>
    </Root>
  )
}

export default IfClauseForm
